/**
 * @file index.tsx
 *
 * @fileoverview Shows an empty box placeholder for the gallery section of organizations.
 */

import React from 'react';
import { useIntl } from 'react-intl';
import { OrganizationEmptyBoxPlaceholder } from '~/jobiqo/components/Organization/Widgets/OrganizationBoxPlaceholder';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { Box } from '~/vcl/atoms/07-box';
import { AddIcon } from '~/vcl/icons/Add';
import { StackImageIcon } from '~/vcl/icons/StackImage';

interface OrganizationGalleryWidgetEmptyProps {
  /**
   * The current resume.
   */
  organization: OrganizationProfile;
  /**
   * The current box id.
   */
  boxId: string;
}

export const OrganizationGalleryWidgetEmpty = ({
  organization,
  boxId,
}: OrganizationGalleryWidgetEmptyProps) => {
  const intl = useIntl();
  return (
    <Box>
      <OrganizationEmptyBoxPlaceholder
        organization={organization}
        field={boxId}
        text={intl.formatMessage({
          id: 'organization_gallery_empty_text',
          defaultMessage: `Enter your organization picture gallery. Pictures help applicant's identify with the culture
                and identity of your brand and organization.`,
        })}
        buttonText={intl.formatMessage({
          id: 'organization_gallery_empty_enter',
          defaultMessage: `Create a gallery`,
        })}
        icon={<StackImageIcon title="Gallery" />}
        buttonIcon={<AddIcon title="gallery" />}
      />
    </Box>
  );
};
